import '.eb{flex-shrink:0;}.ssr-plugin'
import '.h9{min-width:260px;}.ssr-plugin'
import '.o{max-width:480px;}.ssr-plugin'
import '.s{position:relative;}.ssr-plugin'
import '.t{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.ba{user-select:none;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.bf{gap:24px;}.ssr-plugin'
import '.r{flex:1;}.ssr-plugin'
import '.ck{overflow:auto;}.ssr-plugin'
import '.ej{gap:2px;}.ssr-plugin'
import '.ha{padding:8px 8px 4px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.hb{padding-top:4px;}.ssr-plugin'
import '.hc{padding-bottom:4px;}.ssr-plugin'
import '.bu{padding-left:8px;}.ssr-plugin'
import '.fm{padding-right:8px;}.ssr-plugin'
import '.gb{min-height:32px;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.ao{cursor:pointer;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import '.hd{min-height:24px;}.ssr-plugin'
import { ReactNode, createContext, useContext } from 'react'
import { Icon, IconProps } from '../Icon/index.js'
import { colors } from '../../tokens/colors.js'
import { Text } from '../Text/index.js'
import { radius } from '../../utils/radius.js'
import { styled } from 'inlines'
import { Counter } from '../Counter/index.js'

type SidebarContextType = {
  value?: string
  onChange: (value: string) => void
}
const SidebarContext = createContext<SidebarContextType>({ onChange: () => {} })

type SidebarProps = {
  value?: string
  onChange: (value: string) => void
  children: ReactNode
  side?: 'left' | 'right' | false
}

function Sidebar({ children, value, onChange, side = 'left' }: SidebarProps) {
  return (
    <SidebarContext.Provider value={{ value, onChange }}>
      <div className="eb h9 o s t a i ba"
      >
        <div className="f t a i bf"
        >
          {children}
        </div>
      </div>
    </SidebarContext.Provider>
  )
}

type SidebarHeaderProps = {
  children: ReactNode
}

function SidebarHeader({ children }: SidebarHeaderProps) {
  return <div className="a">{children}</div>
}

type SidebarFooterProps = {
  children: ReactNode
}

function SidebarFooter({ children }: SidebarFooterProps) {
  return <div className="a">{children}</div>
}

type SidebarItemsProps = {
  children: ReactNode
}

function SidebarItems({ children }: SidebarItemsProps) {
  return (
    <div className="r bf a f i ck"
    >
      {children}
    </div>
  )
}

type SidebarGroupProps = {
  children: ReactNode
  title: string
}

function SidebarGroup({ title, children }: SidebarGroupProps) {
  return (
    <div className="a i ej">
      <div className="ha">
        <Text selectableText={false} variant="subtext-medium" color="neutral60">
          {title}
        </Text>
      </div>
      {children}
    </div>
  )
}

type SidebarItemProps = {
  children: ReactNode
  value: string
  icon?: IconProps['variant']
  description?: string
  counter?: number
}

function SidebarItem({
  children,
  value,
  icon,
  description,
  counter,
}: SidebarItemProps) {
  const { value: contextValue, onChange } = useContext(SidebarContext)
  const active = value === contextValue

  return (
    <styled.div className="a d hb hc bu fm gb d2 ao"
      data-active={active ? active : undefined}
      style={{
        borderRadius: radius[12],
        '&:hover:not([data-active])': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]': {
          background: colors.neutral10Adjusted,
        },
        '&[data-active]:hover': {
          background: colors.neutral10Adjusted,
        },
      }}
      onClick={() => {
        onChange(value)
      }}
    >
      {icon && <Icon variant={icon} />}
      <div className="a i c a8 hd"
      >
        <Text selectableText={false} color="neutral80" variant="display-medium">
          {children}
        </Text>
        {description && (
          <Text
            selectableText={false}
            color="neutral60"
            variant="subtext-regular"
          >
            {description}
          </Text>
        )}
      </div>
      {counter && <Counter style={{ marginLeft: 'auto' }}>{counter}</Counter>}
    </styled.div>
  )
}

Sidebar.Items = SidebarItems
Sidebar.Group = SidebarGroup
Sidebar.Item = SidebarItem
Sidebar.Header = SidebarHeader
Sidebar.Footer = SidebarFooter

export { Sidebar }
export type { SidebarProps }
